export default `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1000" height="1000" viewBox="0 0 1000 1000">
  <defs>
    <clipPath id="clip-path">
      <path id="Path_72" data-name="Path 72" d="M0,407.826H735.844V-328H0Z" transform="translate(0 328)" fill="#02B0FE"/>
    </clipPath>
    <clipPath id="clip-Logo_Icon_Negative">
      <rect width="1000" height="1000"/>
    </clipPath>
  </defs>
  <g id="Logo_Icon_Negative" data-name="Logo Icon Negative" clip-path="url(#clip-Logo_Icon_Negative)">
    <g id="Group_3720" data-name="Group 3720" transform="translate(132.114 132.087)">
      <g id="Group_152" data-name="Group 152" clip-path="url(#clip-path)">
        <g id="Group_151" data-name="Group 151" transform="translate(0 0)">
          <path id="Path_71" data-name="Path 71" d="M407.836,203.914C407.836.719,243.112-164,39.907-164-163.268-164-328.008.719-328.008,203.914s164.74,367.911,367.915,367.911c203.2,0,367.929-164.72,367.929-367.911M223.494,29.631l-74.509,74.511c0-.011-.02-.011-.02-.027l-19.378,19.374A120.335,120.335,0,1,0,44.493,328.917a120.542,120.542,0,0,0,117.3-93.454H17.606L71.362,181.7H216.494a174.549,174.549,0,0,1,2.084,26.873c0,96.005-78.094,174.1-174.086,174.1A173.522,173.522,0,0,1-78.518,331.648l-25.343,25.341h-76.077l69.361-69.313a173.125,173.125,0,0,1-19.019-79.1c0-95.989,78.1-174.086,174.09-174.086a173.246,173.246,0,0,1,79.162,18.954l23.813-23.811Z" transform="translate(328.008 164.001)" fill="#02B0FE"/>
        </g>
      </g>
    </g>
  </g>
</svg>`